import React from "react";

export default function App() {
  return (
    <div className="container">
      <h1>Child Safety and Protection Policy</h1>
      <p className="updated">Last updated: January 2026</p>

      <section>
        <h2>Our Commitment</h2>
        <p>
          We are committed to providing a safe and secure experience for all
          users. Any form of child sexual abuse, exploitation, or harmful
          content is strictly prohibited.
        </p>
      </section>

      <section>
        <h2>Prohibited Content</h2>
        <ul>
          <li>Child sexual abuse material (CSAM)</li>
          <li>Sexual or suggestive content involving minors</li>
          <li>Grooming, exploitation, or abuse of children</li>
          <li>Harassment or harmful behavior toward minors</li>
        </ul>
      </section>

      <section>
        <h2>Age Restrictions</h2>
        <p>
          Users under the age of 18 are not permitted to access adult or
          dating-related features. We actively enforce age restrictions.
        </p>
      </section>

      <section>
        <h2>Prevention and Moderation</h2>
        <ul>
          <li>Content moderation using automated and manual review</li>
          <li>User reports are reviewed promptly</li>
          <li>Accounts violating child safety rules are suspended</li>
        </ul>
      </section>

      <section>
        <h2>Reporting Concerns</h2>
        <p>
          If you encounter content or behavior that violates this policy,
          please report it immediately.
        </p>
        <p>
          📧 Contact: <strong>cricketsarena.demo@gmail.com</strong>
        </p>
      </section>

      <section>
        <h2>Legal Compliance</h2>
        <p>
          We comply with all applicable local and international child safety
          laws and cooperate fully with law enforcement authorities.
        </p>
      </section>

      <footer>
        <p>© 2026 Color Market. All rights reserved.</p>
      </footer>
    </div>
  );
}